<div class="name-list">
  <div class="names-container">
    @for (name of nameList; track name) {
      <span class="name">{{name}}</span>
    }
  </div>
  <div class="overflow-count">
    <span class="overflow-counter"></span>
  </div>
</div>
